import { contactInfo, socials } from "../../../data/info";

export function GetInfo() {
    return contactInfo;
}

export function GetSocials() {
    return socials;
}